import type { SinkConfig } from '../../../../Flux/Slice/Visualization/VisualizationSliceTypes.js'
import type { SinkTypeKey } from './SinkRegistry.js'
import { SINK_REGISTRY } from './SinkRegistry.js'

/**
 * Chart types that draw the same numbers differently. A switch stays inside one family, and every family has a
 * single render mode, so the sink's panel ids (and with them its place in the grid) survive the switch.
 */
const FAMILIES: SinkTypeKey[][] = [
  ['stackedBar', 'areaChart', 'lineChart'],
  ['pieChart', 'treemap', 'rankedBar'],
  ['biodiversityRichness', 'biodiversityShannon', 'biodiversityGiniSimpson', 'biodiversityAbsoluteEffective'],
  ['overlapHeatmap', 'upset', 'sharedUnique']
]

export function alternativeKinds(kind: SinkTypeKey): SinkTypeKey[] {
  return FAMILIES.find((family) => family.includes(kind))?.filter((k) => k !== kind) ?? []
}

export function kindLabel(kind: SinkTypeKey): string {
  return SINK_REGISTRY[kind].makeConfig('label' as SinkConfig['id']).title ?? kind
}

/** Same id, the new kind's default params; a title the user chose survives, a default title follows the kind. */
export function switchSinkKind(config: SinkConfig, kind: SinkTypeKey): SinkConfig {
  const next = SINK_REGISTRY[kind].makeConfig(config.id)
  const renamed = config.title !== undefined && config.title !== kindLabel(config.kind)
  return renamed ? { ...next, title: config.title } : next
}
